// @flow

let innerWindow = typeof window !== 'undefined' ? window : null;
let innerDoc = typeof window !== 'undefined' && window.document ? window.document : null;

function getWindow(): Promise<Object> {
  return new Promise((resolve,reject) => {
    if (innerWindow) {
      resolve(innerWindow);
    } else {
      reject(null);
    }
  });
}

function getDocument(): Promise<Document> {
  return new Promise((resolve,reject) => {
    if (innerDoc) {
      resolve(innerDoc);
    } else {
      reject(null);
    }
  });
}

function isMobileSafari() {
  let ua = window.navigator.userAgent;
  let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  let webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
}

function isSafari10() {
  let versionRes = window.navigator.userAgent.match(/Version\/([\d\.]+)(?: Mobile\/[\dA-Z]+)? Safari\/[\d\.]+/);

  if (versionRes && versionRes.length === 2) {
    let version = parseInt(versionRes[1]);
    return version === 10;
  }
}

export {
  getWindow,
  getDocument,
  isMobileSafari,
  isSafari10
};